import './video-block.scss';
import 'magnific-popup';

export default () => {
	// Magnific popup
	$( '.video-block .js-youtube-video' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		iframe: {
			patterns: {
				vimeo: {
					index: 'vimeo.com/',
					id: '/',
					src: '//player.vimeo.com/video/%id%?autoplay=1&title=0&byline=0&portrait=0&mute=1',
				},
			},
		},
		callbacks: {
			beforeOpen: function () {
				// Get the href attribute of the clicked element
				let href = $( this.st.el ).attr( 'href' );

				// Update the src property with the href
				this.st.iframe.src = `//player.vimeo.com/video/${getVimeoId( href )}&autoplay=1&title=0&byline=0&portrait=0&mute=1`;
			},
		},
	} );

	function getVimeoId ( url ) {
		let regExp = /vimeo\.com\/(?:.*\/)?(\d+)/;
		let match = url.match( regExp );

		return match[ 1 ];
	}
};
